import RecoveryForm from "../../components/forms/authorization/RecoveryForm";
import AuthorizationBase from "./AuthorizationBase";
import {useState} from "react";
import RecoverySubmitForm from "../../components/forms/authorization/RecoverySubmitForm";
import {useParams, useSearchParams} from "react-router-dom";
import { useI18n } from "../../i18n/I18nProvider";

const RecoverySendedMessage = () => {
    const { t } = useI18n();
    return (
        <div>
            {t("Сообщение отправлено")}
        </div>
    )
}

const RecoveryPage = () => {
    const [params] = useSearchParams();
    const token = params.get("token")

    return(
        <AuthorizationBase variant="recovery">
            {
                
                token?.length > 50 ?
                    <RecoverySubmitForm token={token}/>
                    :
                    <RecoveryForm/>
            }

        </AuthorizationBase>
    )
}

export default RecoveryPage